// extracted by mini-css-extract-plugin
export default {"main":"a5a1c3a84d","tit":"d3b26c511d","maintitle":"_10d25ca1d2","ylw":"_518bb76853","white":"cf107a8c75","mv_title":"_0b6b870e9b","mv_nc":"_265416749c","mv_in":"_12ee3e2502"};